import { LocalConvenienceStoreOutlined } from '@mui/icons-material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface LoginProps {
  setLoggedIn: (loggedIn: boolean) => void;
  setEmail: (email: string) => void;
  baseUrl: string;
}

const Login: React.FC<LoginProps> = ({ setLoggedIn, setEmail, baseUrl }) => {
  const [email, setEmailState] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');
  const [passwordError, setPasswordError] = useState<string>('');

  const navigate = useNavigate();

  const onButtonClick = () => {
    setEmailError('');
    setPasswordError('');

    if (email === '') {
      setEmailError('Please enter your email');
      return;
    }

    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setEmailError('Please enter a valid email');
      return;
    }

    if (password === '') {
      setPasswordError('Please enter a password');
      return;
    }

    if (password.length < 7) {
      setPasswordError('The password must be 8 characters or longer');
      return;
    }

    checkAccountExists((accountExists: boolean) => {
      if (accountExists) logIn();
      else if (
        window.confirm(
          'An account does not exist with this email address: ' +
            email +
            '. Do you want to create a new account?',
        )
      ) {
        createUser();
      }
    });
  };

  const checkAccountExists = (callback: (exists: boolean) => void) => {
    console.log(baseUrl)
    fetch(baseUrl + 'check-account', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    })
      .then((r) => r.json())
      .then((r) => {
        callback(r?.userExists);
      });
  };

  const logIn = () => {
    fetch(baseUrl + 'auth', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    })
      .then((r) => r.json())
      .then((r) => {
        if (r.message === 'success') {
          localStorage.setItem('user', JSON.stringify({ email, token: r.token }));
          setLoggedIn(true);
          setEmail(email);
          navigate('/');
        } else {
          setPasswordError('Wrong email or password');
        }
      });
  };

  const createUser = () => {
    fetch(baseUrl + 'users', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    })
      .then((r) => r.json())
      .then((r) => {
        if (r.message === 'success') {
          localStorage.setItem('user', JSON.stringify({ email, token: r.token }));
          setLoggedIn(true);
          setEmail(email);
          navigate('/');
        } else {
          setPasswordError('Wrong email or password');
        }
      });
  };

  return (
    <div>
      <div className="titleContainer">
        <div>Login</div>
      </div>
      <br />
      <div className="inputContainer">
        <input
          value={email}
          placeholder="Enter your email here"
          onChange={(ev) => setEmailState(ev.target.value)}
          className="inputBox"
        />
        <label className="errorLabel">{emailError}</label>
      </div>
      <br />
      <div className="inputContainer">
        <input
          value={password}
          placeholder="Enter your password here"
          onChange={(ev) => setPassword(ev.target.value)}
          className="inputBox"
          type="password"
        />
        <label className="errorLabel">{passwordError}</label>
      </div>
      <br />
      <div className="inputContainer">
        <input className="inputButton" type="button" onClick={onButtonClick} value="Log in" />
      </div>
    </div>
  );
};

export default Login;
